module.exports = __webpack_public_path__ + "img/house_img4.d01c73df.png";